import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { HeaderDigitalMenuBlockConfig } from '@front-platform/content-builder';
import { headerDigitalMenuBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';

import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';
export interface HeaderDigitalMenuBlockRuntimeConfig {}

export type HeaderDigitalMenuBlockConfigInput = Partial<
  Omit<HeaderDigitalMenuBlockConfig, keyof HeaderDigitalMenuBlockRuntimeConfig> &
    HeaderDigitalMenuBlockRuntimeConfig
>;
export type HeaderDigitalMenuBlockResolvedConfig = Omit<
  HeaderDigitalMenuBlockConfig,
  keyof HeaderDigitalMenuBlockRuntimeConfig
> &
  Partial<HeaderDigitalMenuBlockRuntimeConfig>;
export interface HeaderDigitalMenuBlockContract extends ConfigComponentContract<
  HeaderDigitalMenuBlockConfigInput,
  HeaderDigitalMenuBlockResolvedConfig
> {}

@Component({
  selector: 'app-header-digital-menu',
  templateUrl: './header-digital-menu-block.component.html',
  standalone: false,
})
export class HeaderDigitalMenuBlockComponent implements HeaderDigitalMenuBlockContract {
  readonly config = input<HeaderDigitalMenuBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    HeaderDigitalMenuBlockConfig,
    HeaderDigitalMenuBlockRuntimeConfig
  >(headerDigitalMenuBlockResolveConfig, () => ({ config: this.config() }));
  locales$ = this.marketplaceSelector.selectMarketplaceLocales;

  constructor(private marketplaceSelector: MarketplaceStoreSelector) {}
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(HeaderDigitalMenuBlockComponent, {
  'keyAliases': {},
});
